var memo = 0;
var generate = function generate() {
  memo++;
  return "temp-id-" + memo;
};
var tempId = {
  generate: generate
};
export { tempId, generate as generateTempId };